<template>
  <div class="proposal-profile">
    <proposal-PO-info
      v-if="isDeliveredForObligation"
      :details="proposalRequestInfo"
    />

    <!-- Identificación del Perfil -->
    <div>
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        title="Identificación del Perfil"
        title-class="proposal-profile__section-title__info"
      />
      <div class="general-info bg-secondary-3 px-4 py-3 rounded">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="title">Tipo de proveedor:</span>
            <p class="content">{{ profile.hiringType }}</p>
          </div>
          <div v-if="profile.socialSecurityNo" class="col-md-3 col-12">
            <span class="title">Número de seguro social patronal:</span>
            <p class="content">{{ profile.socialSecurityNo | empty }}</p>
          </div>
          <div
            v-if="profile.isProvisionalRemedyServiceChecked"
            class="col-md-3 col-12"
          >
            <span class="title">Servicios a ofrecer:</span>
            <p class="content">
              {{ profile.proposalServiceTypeName }}
            </p>
          </div>
          <div v-if="isSpecialEducationArea" class="col-md-6 col-12">
            <span class="title">
              ¿Es usted un proveedor que actualmente tiene contratos con el DE
              para la provisión de servicios educativos o educativos y
              terapias?:
            </span>
            <p class="content">
              {{ profile.questionYesOrNoProcedure ? 'Sí' : 'No' }}
            </p>
          </div>
          <div
            v-if="isOmepArea || isInfrastructureArea"
            class="col-md-3 col-12"
          >
            <span class="title">Número de RUL:</span>
            <p class="content">{{ profile.rulNumber | empty }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Información General del Proponente -->
    <div>
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        title="Información General del Proponente"
        title-class="proposal-profile__section-title__info"
      />
      <div class="general-info bg-secondary-3 px-4 py-3 rounded">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="title">Nombre del proponente:</span>
            <p class="content">{{ profile.corporationName }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="title">Correo electrónico:</span>
            <p class="content">{{ profile.proposalEmail }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="title">Teléfono:</span>
            <p class="content">{{ profile.telephone | phone }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="title">Monto total de la propuesta a someter:</span>
            <p class="content">{{ profile.proposalAmount | price }}</p>
          </div>
          <div v-if="isProvisionalRemedyArea" class="col-md-3 col-12">
            <span class="title">
              Tiempo ofreciendo los servicios propuestos:
            </span>
            <p class="content">{{ profile.serviceOfferTimeAndTerm }}</p>
          </div>
          <div
            v-if="isOmepArea || isInfrastructureArea"
            class="col-md-3 col-12"
          >
            <span class="title">Tipo de contratación:</span>
            <p class="content">{{ profile.hiringType | empty }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Información del representante autorizado -->
    <div>
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        title="Información del Representante Autorizado"
        title-class="proposal-profile__section-title__info"
      />
      <div class="general-info bg-secondary-3 px-4 py-3 rounded">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="title">Nombre completo:</span>
            <p class="content">{{ profile.autorizeRepresent }}</p>
          </div>

          <div class="col-md-3 col-12">
            <span class="title">Profesión:</span>
            <p class="content">
              {{ profile.representativeProfession | empty }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--Dirección física del proponente -->
    <div>
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        :title="addressSectionTitle"
        title-class="proposal-profile__section-title__info"
      />
      <div class="general-info bg-secondary-3 px-4 py-3 rounded">
        <div class="row">
          <div class="col">
            <span class="title">Dirección Oficina Central:</span>
            <p class="content">{{ profile.centralOfficeAddress }}</p>
          </div>
          <div
            v-if="isSpecialEducationArea || isInfrastructureArea || isOmepArea"
            class="col"
          >
            <span class="title">
              ¿La corporación, individuo o entidad educativa cuenta con otra
              oficina central?:
            </span>
            <p class="content">{{ profile.hasOtherCentralOffice }}</p>
          </div>
        </div>
      </div>
    </div>

    <!--Áreas Geográficas-->
    <div v-if="isProvisionalRemedyArea">
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        title="Areas Geográficas"
        title-class="proposal-profile__section-title__info"
      />
      <result-not-found v-if="geographyAreaMunicipalities.length == 0" />
      <div
        v-if="geographyAreaMunicipalities.length"
        class="general-info bg-secondary-3 px-4 py-3 rounded"
      >
        <span
          v-for="municipality in geographyAreaMunicipalities"
          :key="municipality.id"
          class="badge badge-pill font-16 color-black mr-2 mb-2 badge-chip"
        >
          {{ municipality.name }}
        </span>
      </div>
    </div>

    <!--Datos de Servicio a Ofrecer-->
    <div v-if="isProvisionalRemedyArea || isSpecialEducationArea">
      <section-title
        class="my-4 proposal-profile__section-title"
        icon="fas fa-info-circle"
        reverse
        title="Datos de Servicio a Ofrecer"
        title-class="proposal-profile__section-title__info"
      />
      <result-not-found v-if="offeringServices.length == 0" />
      <div
        v-if="offeringServices.length"
        class="general-info bg-secondary-3 px-4 py-3 rounded"
      >
        <div class="row">
          <div
            v-for="(services, label) in groupedOfferingServices"
            :key="label"
            class="col col-sm col-12 mb-3"
          >
            <p class="color-gray-6 mb-2 font-14">{{ label }}</p>
            <span
              v-for="service in services"
              :key="service.disciplineTypeId"
              class="badge badge-pill font-16 color-black mr-2 mb-2 badge-chip"
            >
              {{ service.disciplineTypeName }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ResultNotFound from 'custom-result-not-found';
import { getProposalProponentProfile } from '@/modules/serviceProposalHistory/api';
import proposalStatus from '@/utils/shared/constants/proposalStatus';
import serviceTypes from '@/utils/constants/serviceTypes';
import proposalAreas from '@/utils/shared/constants/proposalArea';
import ProposalPOInfo from '@/views/provider/proposalHistory/components/ProposalPoInfo.vue';

export default {
  name: 'ProfileTab',
  components: {
    SectionTitle,
    ResultNotFound,
    ProposalPOInfo,
  },
  props: {
    proposalRequestId: {
      type: Number,
      default: () => 0,
    },
    proposalRequestInfo: {
      type: Object,
      default: () => {},
    },
    canViewContractInfo: {
      type: Boolean,
      dafault: () => false,
    },
  },
  data: () => ({
    profile: {},
  }),
  computed: {
    isDeliveredForObligation() {
      return (
        this.proposalRequestInfo?.proposalRequestStatus?.id ==
        proposalStatus.DeliveredForObligation
      );
    },
    dateOfApproach() {
      return (value) => (value ? this.$options.filters.date(value) : '-');
    },
    geographyAreaMunicipalities() {
      return this.profile?.geographyAreaMunicipalities || [];
    },
    offeringServices() {
      return this.profile?.offeringServices || [];
    },
    isServiceTypeTherapies() {
      return (serviceTypeId) => serviceTypeId === serviceTypes.Therapy;
    },
    groupedOfferingServices() {
      return this.offeringServices.reduce((groups, service) => {
        const label = this.isServiceTypeTherapies(service.serviceTypeId)
          ? 'Terapias'
          : 'Evaluaciones';
        if (!groups[label]) groups[label] = [];
        groups[label].push(service);
        return groups;
      }, {});
    },
    isSpecialEducationArea() {
      return (
        this.profile?.proposalAnnouncementAreaId ===
        proposalAreas.SpecialEducation
      );
    },
    isProvisionalRemedyArea() {
      return (
        this.profile?.proposalAnnouncementAreaId ===
        proposalAreas.ProvisionalRemedy
      );
    },
    isOmepArea() {
      return this.profile?.proposalAnnouncementAreaId === proposalAreas.OMEP;
    },
    isInfrastructureArea() {
      return (
        this.profile?.proposalAnnouncementAreaId ===
        proposalAreas.Infraestructure
      );
    },
    addressSectionTitle() {
      return this.isSpecialEducationArea ||
        this.isInfrastructureArea ||
        this.isOmepArea
        ? 'Dirección Postal del Proponente'
        : 'Dirección Física';
    },
  },
  async mounted() {
    await this.getProponentProfile();
  },
  methods: {
    async getProponentProfile() {
      await getProposalProponentProfile(this.proposalRequestId).then((res) => {
        this.profile = { ...res.data };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.proposal-profile {
  ::v-deep &__section-title {
    .title-icon {
      font-size: 14px;
      color: map-get($colors, 'orange');
    }

    .dot {
      background-color: white;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__info {
      font-size: 1rem;
      @media screen and (min-width: 768px) {
        font-size: 1.125rem;
      }
    }
  }

  .general-info {
    .title {
      font-size: 0.875rem;
      color: map-get($colors, 'gray-6');
    }
    .content {
      font-weight: bold;
      color: map-get($colors, 'black');
    }
  }

  .badge-chip {
    background-color: #fff;
    border: 1px solid map-get($colors, 'gray-2');
    color: map-get($colors, 'black');
    font-size: 0.875rem;
  }

  .service-info {
    font-size: 1.125rem;
    .sub-title {
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 768px) {
    .general-info {
      .content {
        font-weight: normal;
      }
    }
    .service-info {
      font-size: 1rem;
    }
  }
}
</style>
